/**
 * @Author: zachalam
 * @Date:   2017-01-04T13:20:10-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T16:35:07-07:00
 */

import React, { Component } from "react";
import _ from "lodash";
import glamorous from "glamorous";
import Rheostat from "rheostat";
import FilterSection from "./FilterSection";
import Checkbox from "../../common/Checkbox";
import TextInput from "../../common/TextInput";
import Select from "../../common/Select";
import FiltersTravelingTo from "./FiltersTravelingTo";
import FiltersLivingIn from "./FiltersLivingIn";
import { color } from "../../../style/index";
import UserConfig from "../../../config/User";
import {
  metricConv,
  extractDepartureLocationData,
  extractLocationData,
  geocodeByPlaceId
} from "../../../common";
import { connectScreenSize } from "react-screen-size";

const FilterContainer = glamorous.div({
  width: 300,
  "@media(max-width: 800px)": {
    position: "fixed",
    width: "100%",
    zIndex: 1000,
    backgroundColor: color.BRAND_1_DARK,
    height: "100%",
    top: 0,
    overflowY: "scroll"
  }
});

const FilterHeader = glamorous.div({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid #443B5C",
  marginBottom: 15,
  padding: "0 15px 15px 15px"
});

const FilterHeaderText = glamorous.span({
  fontSize: "28px"
});

const SortBy = glamorous.div({
  fontSize: 16
});

const RheostatText = glamorous.div({
  marginBottom: 15,
  textAlign: "center",
  fontWeight: "bold"
});

const FilterButtonContainer = glamorous.div({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "@media(max-width: 800px)": {
    padding: "0 10px 14px 10px"
  }
});

const ApplyFilterButton = glamorous.button({
  height: 45,
  width: 102,
  borderRadius: 5,
  backgroundColor: "#FFFFFF",
  boxShadow: "0 4px 8px 1px rgba(0,0,0,0.3)"
});

const ResetAllButton = glamorous.a({
  width: 69,
  height: 29,
  color: "#FFFFFF",
  fontSize: 18,
  borderBottom: "1px dashed #979797",
  ":hover": {
    cursor: "pointer"
  }
});

const CancelButton = glamorous.button({
  height: 45,
  width: 102,
  borderRadius: 5,
  backgroundColor: color.BRAND_1_DARK,
  border: "2px solid " + color.BRAND_1,
  color: "#FFF",
  ":hover": {
    backgroundColor: color.BRAND_1
  }
});

const CancelContainer = glamorous.div({
  borderBottom: "1px solid #443D5C",
  marginBottom: 15,
  marginTop: 15,
  padding: "0 15px 15px 15px"
});

const HeaderButton = glamorous.a({
  height: 45,
  width: 102,
  color: "#FFF",
  ":hover": {
    cursor: "pointer"
  }
});

const CancelIcon = glamorous.span({
  fontSize: "24px",
  verticalAlign: "middle"
});

const CancelText = glamorous.span({
  fontSize: "16px",
  verticalAlign: "middle"
});

class SearchResultsFilters extends Component {
  state = this.props.filters;

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps.filters });
  }

  onChangeHandler = e => {
    this.setState({ [e.target.id]: e.target.value });
  };

  onChangeBoolean = e => {
    this.setState({ [e.target.id]: !this.state[e.target.id] });
  };

  onChangeDistance = distance => {
    this.setState({ distance });
  };

  onChangeAge = (age_min, age_max) => {
    this.setState({ age_min, age_max });
  };

  onCheckBoxChange = (attr, theVal) => {
    // assign create arrays for each checkbox input block
    if (this.isCheckBoxChecked(attr, theVal)) {
      // remove item from array.
      this.setState({
        [attr]: _.remove(this.state[attr], n => {
          return n != theVal;
        })
      });
    } else {
      // add item to array
      let newState = this.state[attr].slice();
      newState.push(theVal);
      this.setState({ [attr]: newState });
    }
  };

  isCheckBoxChecked = (attr, theVal) => {
    // returns value of Checkbox item
    let theArray = this.state[attr];
    let returnVal = _.includes(theArray, theVal);
    return returnVal;
  };

  onChangeHeight = (height_min, height_max) => {
    this.setState({ height_min, height_max });
  };

  onDepartingFromText = value => {
    this.setState({ departing_from_text: value });
  };

  onLeaveSelected = date => {
    // set leaving object, datetime, and new minReturningDate
    let newState = {
      leaving: date,
      leaving_dt: date._d
    };

    if (!this.state.returning) {
      newState.returning = date;
      newState.returning_dt = date._d;
    }

    this.setState(newState);
  };

  onReturnSelected = date => {
    // return date time
    this.setState({ returning: date, returning_dt: date._d });
  };

  onDatePickerReset = type => {
    this.setState({
      leaving: null,
      leaving_dt: null,
      returning: null,
      returning_dt: null
    });
  };

  onDepartingFromSelected = (address, placeId) => {
    geocodeByPlaceId(placeId).then(results => {
      const location = results[0];
      if (!location) {
        console.error("Error with result Data");
        return;
      }

      let depLocData = extractDepartureLocationData(location);
      let locData = extractLocationData(location);
      // save departing location data
      this.setState({ ...depLocData });
      // set departing location text
      let departing_from_text = `${locData.city ? locData.city + ", " : ""}${
        locData.region ? locData.region + ", " : ""
      }${locData.country ? locData.country : ""}`;
      this.setState({ departing_from_text });
    });
  };

  onDepartingFromText = value => {
    this.setState({ departing_from_text: value });
  };

  onDepartingFromReset = () => {
    this.setState({ departing_from_text: "" });
  };

  runSearch = () => {
    this.props.saveFilters({
      formData: this.state,
      filterMembersLivingIn: this.props.memberSearch
    });
    window.scrollTo(0, 0);

    if (this.props.memberSearch) {
      this.props.refreshProfile();
    } else {
      this.props.refreshTrips();
    }
  };

  resetFilters = () => {
    const { defaultFilters } = this.props;

    this.setState({...defaultFilters, keywords: '', leaving: '', returning: ''})

  };

  render() {
    const { search, memberSearch } = this.props;

    const { has_photo, online } = this.state;

    return (
      <FilterContainer>
        {(this.props.small || this.props.mobile) && (
          <div>
            <CancelContainer>
              <HeaderButton onClick={this.props.filterClickHandler}>
                <CancelIcon> X </CancelIcon>
                <CancelText> Cancel </CancelText>
              </HeaderButton>
            </CancelContainer>
            <FilterHeader>
              <FilterHeaderText> Filters </FilterHeaderText>
              <ResetAllButton onClick={this.resetFilters}>
                Reset All
              </ResetAllButton>
            </FilterHeader>
          </div>
        )}
        <FilterSection isCollapsable={false}>
          <SortBy>
            {" "}
            Sort By: &nbsp;
            <Select
              onChange={this.onChangeHandler}
              value={this.state.order}
              id="order"
              arrow="light"
              dropdownStyle="mt-purple"
              dropdownStyleOptions={{ width: "164", fontSize: "16" }}
            >
              <option value="recent">Recently Logged In</option>
              <option value="newest">Newest Member</option>
              <option value="oldest">Oldest Member</option>
              <option value="distance">Nearest Distance</option>
            </Select>
          </SortBy>
        </FilterSection>
        <FilterSection isCollapsable={false}>
          <Checkbox
            size="MD"
            label="Has photos"
            onChange={this.onChangeBoolean}
            value={has_photo}
            id="has_photo"
          />
          <Checkbox
            size="MD"
            label="Is online"
            onChange={this.onChangeBoolean}
            value={online}
            id="online"
          />
        </FilterSection>

        {!memberSearch ? 
            <FiltersTravelingTo
              leaving={this.state.leaving}
              returning={this.state.returning}
              departing_from_text={this.state.departing_from_text}
              onCheckBoxChange={this.onCheckBoxChange}
              onChangeHandler={this.onChangeHandler}
              isCheckBoxChecked={this.isCheckBoxChecked}
              onLeaveSelected={this.onLeaveSelected}
              onReturnSelected={this.onReturnSelected}
              onDepartingFromSelected={this.onDepartingFromSelected}
              onDepartingFromText={this.onDepartingFromText}
              onDepartingFromReset={this.onDepartingFromReset}
              onDatePickerReset={this.onDatePickerReset}
            /> :
            <FiltersLivingIn
              distance={this.state.distance}
              onChangeHandler={this.onChangeHandler}
              onChangeDistance={this.onChangeDistance}
              RheostatText={RheostatText}
              Checkbox={Checkbox}
            />
        }

        <FilterSection
          header='Age'
        >
          <RheostatText> {this.state.age_min} – {this.state.age_max} </RheostatText>
          <Rheostat
            min={UserConfig.minimumAge}
            max={UserConfig.maximumAge}
            values={[this.state.age_min, this.state.age_max]}
            onChange={e => {
              this.onChangeAge(e.values[0], e.values[1]);
            }}
          />
        </FilterSection>
        <FilterSection header="Ethnicity">
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 1)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 1);
            }}
            label="Asian"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 2)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 2);
            }}
            label="Black / African"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 3)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 3);
            }}
            label="Latin / Hispanic"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 4)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 4);
            }}
            label="Indian"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 5)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 5);
            }}
            label="Middle Eastern"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 6)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 6);
            }}
            label="Mixed"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 7)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 7);
            }}
            label="Native American"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 8)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 8);
            }}
            label="Pacific Islander"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 9)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 9);
            }}
            label="White / Caucasian"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("ethnicity", 10)}
            onChange={() => {
              this.onCheckBoxChange("ethnicity", 10);
            }}
            label="Other"
          />
        </FilterSection>
        <FilterSection header="Height">
          <RheostatText>
            {metricConv(this.state.height_min)} –{" "}
            {metricConv(this.state.height_max)}
          </RheostatText>
          <Rheostat
            min={UserConfig.minimumHeight}
            max={UserConfig.maximumHeight}
            values={[this.state.height_min, this.state.height_max]}
            snap={true}
            onChange={e => {
              this.onChangeHeight(e.values[0], e.values[1]);
            }}
          />
        </FilterSection>
        <FilterSection header="Body Type">
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("body_type", 1)}
            onChange={() => {
              this.onCheckBoxChange("body_type", 1);
            }}
            label="Slim / Slender"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("body_type", 2)}
            onChange={() => {
              this.onCheckBoxChange("body_type", 2);
            }}
            label="Athletic"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("body_type", 3)}
            onChange={() => {
              this.onCheckBoxChange("body_type", 3);
            }}
            label="Average"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("body_type", 4)}
            onChange={() => {
              this.onCheckBoxChange("body_type", 4);
            }}
            label="A few extra pounds"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("body_type", 5)}
            onChange={() => {
              this.onCheckBoxChange("body_type", 5);
            }}
            label="Full / Overweight"
          />
        </FilterSection>
        <FilterSection header="Relationship Status">
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("relationship_status", 1)}
            onChange={() => {
              this.onCheckBoxChange("relationship_status", 1);
            }}
            label="Single"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("relationship_status", 2)}
            onChange={() => {
              this.onCheckBoxChange("relationship_status", 2);
            }}
            label="Divorced"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("relationship_status", 3)}
            onChange={() => {
              this.onCheckBoxChange("relationship_status", 3);
            }}
            label="Widowed"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("relationship_status", 4)}
            onChange={() => {
              this.onCheckBoxChange("relationship_status", 4);
            }}
            label="Seperated"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("relationship_status", 5)}
            onChange={() => {
              this.onCheckBoxChange("relationship_status", 5);
            }}
            label="Married"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("relationship_status", 6)}
            onChange={() => {
              this.onCheckBoxChange("relationship_status", 6);
            }}
            label="In a open relationship"
          />
        </FilterSection>
        <FilterSection header="Smoking">
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("smoking", 1)}
            onChange={() => {
              this.onCheckBoxChange("smoking", 1);
            }}
            label="Non smoker"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("smoking", 2)}
            onChange={() => {
              this.onCheckBoxChange("smoking", 2);
            }}
            label="Light smoker"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("smoking", 3)}
            onChange={() => {
              this.onCheckBoxChange("smoking", 3);
            }}
            label="Heavy smoker"
          />
        </FilterSection>
        <FilterSection header="Drinking">
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("drinking", 1)}
            onChange={() => {
              this.onCheckBoxChange("drinking", 1);
            }}
            label="Non-Drinker"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("drinking", 2)}
            onChange={() => {
              this.onCheckBoxChange("drinking", 2);
            }}
            label="Social drinker"
          />
          <Checkbox
            size="MD"
            value={this.isCheckBoxChecked("drinking", 3)}
            onChange={() => {
              this.onCheckBoxChange("drinking", 3);
            }}
            label="Heavy drinker"
          />
        </FilterSection>
        <FilterSection header="Profile Keywords">
          <TextInput
            className="textInput"
            type="text"
            id="keywords"
            name="keywords"
            placeholder="Keyword Search"
            onChange={this.onChangeHandler}
            value={this.state.keywords}
          />
        </FilterSection>

        {this.props.small || this.props.mobile ? (
          <FilterButtonContainer>
            <CancelButton onClick={this.props.filterClickHandler}>
              Close
            </CancelButton>
            <ApplyFilterButton
              onClick={e => {
                this.props.filterClickHandler();
                this.runSearch();
              }}
            >
              Apply
            </ApplyFilterButton>
          </FilterButtonContainer>
        ) : (
          <FilterButtonContainer>
            <ResetAllButton onClick={this.resetFilters}>
              Reset All
            </ResetAllButton>
            <ApplyFilterButton onClick={this.runSearch}>
              Apply
            </ApplyFilterButton>
          </FilterButtonContainer>
        )}
      </FilterContainer>
    );
  }
}

const mapScreenToProps = screenSize => {
  return screenSize;
};

export default connectScreenSize(mapScreenToProps)(SearchResultsFilters);



// WEBPACK FOOTER //
// ./src/components/pages/Search/SearchResultsFilters.jsx